import { z } from 'zod'

export default {
  id: z.string().trim().nonempty('Id required'),
  label: z.string().trim().nonempty('Label required'),
  instructionsToFillValue: z.string().optional(),
}
